/**
 * BFCM Weekender / Backpack Bundle — free-gift guard
 *
 * These kits already include a Luggage Tag via the Kaching Bundle offer.
 * Kaching Cart's automatic progress-bar "Free gift" also adds Luggage Tag
 * once the cart hits the gift tier, which doubles the tag.
 *
 * When either bundle is in the cart, remove auto free-gift Luggage Tag lines.
 * Paid Luggage Tag adds (no Free gift discount) are left alone.
 */
(function () {
  'use strict';

  var BUNDLE_HANDLES = {
    'aerless-weekender-bundle': true,
    'aerless-backpack-bundle': true
  };
  var GIFT_HANDLE = 'luggage-tag';
  var busy = false;
  var debounceTimer = null;

  function cartHasBundle(cart) {
    return (cart.items || []).some(function (item) {
      return BUNDLE_HANDLES[item.handle];
    });
  }

  function isAutoFreeGiftLuggage(item) {
    if (!item || item.handle !== GIFT_HANDLE) return false;
    if (item.final_line_price === 0 || item.final_price === 0) return true;
    var discounts = item.discounts || [];
    for (var i = 0; i < discounts.length; i++) {
      var title = (discounts[i] && discounts[i].title) || '';
      if (/free\s*gift/i.test(title) || /tier\s*\d+\s*reward/i.test(title)) {
        return true;
      }
    }
    var props = item.properties || {};
    for (var key in props) {
      if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
      var val = String(props[key] || '');
      if (/free\s*gift/i.test(key) || /free\s*gift/i.test(val) || /_gift/i.test(key)) {
        return true;
      }
    }
    return false;
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (res) {
      return res.json();
    });
  }

  function scrub(cart) {
    if (!cart || !cartHasBundle(cart) || busy) return Promise.resolve(cart);

    var victims = (cart.items || []).filter(isAutoFreeGiftLuggage);
    if (!victims.length) return Promise.resolve(cart);

    busy = true;
    var chain = Promise.resolve(cart);
    victims.forEach(function (item) {
      chain = chain.then(function () {
        return removeLine(item.key);
      });
    });
    return chain
      .then(function (latest) {
        busy = false;
        try {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', { bubbles: true, detail: { cart: latest } })
          );
        } catch (e) {}
        return latest;
      })
      .catch(function () {
        busy = false;
        return cart;
      });
  }

  function fetchAndScrub() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(scrub)
      .catch(function () {});
  }

  function scheduleScrub() {
    if (debounceTimer) clearTimeout(debounceTimer);
    // Kaching Cart often adds the gift a beat after cart:change
    debounceTimer = setTimeout(fetchAndScrub, 400);
    setTimeout(fetchAndScrub, 1200);
  }

  document.addEventListener('cart:change', scheduleScrub);
  document.addEventListener('cart:updated', scheduleScrub);
  document.addEventListener('product:added', scheduleScrub);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScrub);
  } else {
    scheduleScrub();
  }
})();
